import { render } from "./MobileAsideComp.vue?vue&type=template&id=2ca8caf7&scoped=true&ts=true"
import script from "./MobileAsideComp.vue?vue&type=script&lang=ts"
export * from "./MobileAsideComp.vue?vue&type=script&lang=ts"

import "./MobileAsideComp.vue?vue&type=style&index=0&id=2ca8caf7&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\Code\\VSProjects\\modboxProject\\modbox\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ca8caf7"]])

export default __exports__